import { Card, Text } from '@ui/themed';
import { t } from 'i18next';
import { OptionalDetail } from './optional-detail';
import { TwoColumnLayout } from './two-column-layout';

export function CustomerIdentifierCard({
  platformId,
  legacyId,
  internalId,
}: {
  platformId?: string;
  legacyId?: string;
  internalId: string;
}) {
  return (
    <Card>
      <Card.Header headingLevel="h2">
        {t('features:customers.components.customer_identifier_card.header')}
      </Card.Header>
      <Card.Body>
        <TwoColumnLayout>
          <TwoColumnLayout.Column>
            <Text>{t('features:customers.components.customer_identifier_card.platform_id')}</Text>
          </TwoColumnLayout.Column>
          <TwoColumnLayout.Column>
            <OptionalDetail value={platformId} />
          </TwoColumnLayout.Column>
          <TwoColumnLayout.Column>
            <Text>{t('features:customers.components.customer_identifier_card.legacy_id')}</Text>
            <Text>{t('features:customers.components.customer_identifier_card.internal_id')}</Text>
          </TwoColumnLayout.Column>
          <TwoColumnLayout.Column>
            <OptionalDetail value={legacyId} />
            <OptionalDetail value={internalId} />
          </TwoColumnLayout.Column>
        </TwoColumnLayout>
      </Card.Body>
    </Card>
  );
}
